<template>
  <div class="hello">
    <h1>VOK</h1>
    <small>Přístavení velkoobjemových kontejnerů</small>

    <h1>{{ today }}</h1>
    <br/>

    <div v-if="error">
      <h2>ERROR: {{ error }}</h2>
    </div>

    <div v-if="!error">
      <div>
        <h2>Aktuální</h2>
        <table class="my-table">
          <tr v-for="(ulice , index) in aktualni" v-bind:key="index">
            <td>{{ ulice.ulice }}</td>
            <td>{{ getFormattedDate(ulice.pristavenoOd)}}</td>
          </tr>
        </table>
      </div>

      <div>
        <h2>Budoucí</h2>
        <table class="my-table">
          <tr v-for="(ulice , index) in budouci" v-bind:key="index">
            <td>{{ ulice.ulice }}</td>
            <td>{{ getFormattedDate(ulice.termin)}}</td>
          </tr>
        </table>
      </div>
    </div>

    <!-- <hr/>
    <div>
      <h2>Rozpis</h2>
      <table class="my-table">
        <tr v-for="(ulice , index) in data" v-bind:key="index">
          <td>{{ ulice.ulice }}</td>
          <td>{{ ulice.dny[0] }}</td>
          <td>{{ ulice.dny[1] }}</td>
          <td>{{ ulice.dny[2] }}</td>
          <td>{{ ulice.dny[3] }}</td>
          <td>{{ ulice.dny[4] }}</td>
          <td>{{ ulice.dny[5] }}</td>
          <td>{{ ulice.dny[6] }}</td>
          <td>{{ ulice.dny[7] }}</td>
          <td>{{ ulice.dny[8] }}</td>
          <td>{{ ulice.dny[9] }}</td>
          <td>{{ ulice.dny[10] }}</td>
          <td>{{ ulice.dny[11] }}</td>
        </tr>
      </table>
    </div> -->
  </div>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue';

const error = ref(null)
const data = ref(null);
const aktualni = ref([]);
const budouci = ref([])
const structuredData = ref([])
const today = new Date().toLocaleDateString("cs-CZ")

onMounted(() => {
  loadKarvinaData()
})

async function loadKarvinaData() {

  let url = location.pathname + "api/v1/karvina"
  console.log("Getting data from: " + url)
  
  await fetch(url)
    .then(function(response) { 
      if (response.status == 200) {
        response.json().then(function(json) {
          data.value = json
          transformToDates()
          // console.log(data.value)
        })
      } else {
        response.text().then(function(e) {
          error.value = e
        })
      }
    })
    .catch(function(error) {
      console.log("Problem" + error.message)
    })
}

watch(structuredData, (newVal) => {
  let dateNow = new Date()
  newVal.forEach(ulice => {
    ulice.dny.forEach(den => {
      if ((den < dateNow) && (addDays(den, 10) >= dateNow)) {
        ulice.pristavenoOd = den
        aktualni.value.push(ulice)
      }
    })
  })
})

watch(structuredData, (newVal) => {
  let results = []
  let dateNow = new Date()
  newVal.forEach(ulice => {
    ulice.dny.forEach(den => {
      if ((den > dateNow) && (removeDays(den, 365) <= dateNow)) {
        results.push({...ulice,"termin":den})
      }
    })
  })

  const sorter = (a, b) => a.termin > b.termin ? 1 : -1;
  results.sort(sorter)

  budouci.value = results
})

async function transformToDates() {
  let results = []
  data.value.forEach(ulice => {
    let dataPristaveni = []

    ulice.dny.forEach((denVMesici, index) => {
      if(denVMesici != 0) {
        let datum = new Date(new Date().getFullYear(), index, denVMesici)
        dataPristaveni.push(datum)
      }
    })

    results.push({"ulice":ulice.ulice,"dny":dataPristaveni})
  })

  structuredData.value = results
}

function addDays(date, days) {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

function removeDays(date, days) {
  var result = new Date(date);
  result.setDate(result.getDate() - days);
  return result;
}

function getFormattedDate(date) {
  return date.toLocaleDateString("cs-CZ")
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

table.my-table {
  margin: auto;
  text-align: left;
}

table.my-table td {
  padding: 10px;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}
</style>
